import React, { useState, useEffect, useRef } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { yourSummary } from "../../configs/routes";
import { SummaryReportCard } from "../../components/summary/SummaryReportCard";
import {
	loadSummaryDefinitions,
	setIsOnChartScreen,
} from "../../services/summaryReportsService";
import { LoadingSpinner } from "../../components/common/LoadingSpinner";
import { codes as supportedCodes } from "../../configs/supportedResponseCodes.json";
import { getUserSettings } from "../../services/userService";

export const YourSummary = () => {
	const [isLoading, setIsLoading] = useState(true);

	const [summaryDefs, setSummaryDefs] = useState([]);

	const [userSettings] = useState(getUserSettings());

	const mounted = useRef(false);

	useEffect(() => {
		mounted.current = true;
		setIsOnChartScreen(true);

		setIsLoading(true);
		loadSummaryDefinitions()
			.then((result) => {
				if (mounted.current === true) {
					const data = result.data;
					setSummaryDefs(data);
					setIsLoading(false);
				}
			})
			.catch((error) => {
				console.error("Error getting summaryDefs: ", error);

				if (mounted.current === true) {
					setIsLoading(false);
				}
			});

		return () => {
			setIsOnChartScreen(false);
			mounted.current = false;
		};
	}, []);

	const [routes, setRoutes] = useState(null);

	useEffect(() => {
		let r = null;
		const filtered = summaryDefs.filter((e) => {
			if (e.code === "cost" && !userSettings.yourControl.keepExpensesDiary) {
				return false;
			}

			const contains = supportedCodes.some((w) => w.code === e.code);

			return contains;
		});

		if (filtered.length > 0) {
			r = filtered.map((e) => (
				<Route key={e.code} path={getPath(e.code)}>
					<SummaryReportCard
						code={e.code}
						def={e.def}
						pathRoot={getPath(e.code)}
					/>
				</Route>
			));
		}
		setRoutes(r);
	}, [summaryDefs]);

	const getPath = (route) => {
		return `${yourSummary}/${route}`;
	};

	return (
		<>
			<Switch>
				{routes ?? null}
				{isLoading ? (
					<LoadingSpinner />
				) : (
					<Redirect to={getPath(supportedCodes[0].code)} />
				)}
			</Switch>
		</>
	);
};
